//admin utility

import { HttpClient, HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
import { ExcelService } from './excel.service';
import { MatTable } from '@angular/material/table';

import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { EnergyProvidersModalComponent } from '../admin-utility/energy-providers-modal/energy-providers-modal.component';
import { SnackbarComponent } from '../snackbar/snackbar.component';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

// import { AdminUtilityReportComponent } from '../admin-utility/admin-utility-report/admin-utility-report.component'
import { ItemsList } from '@ng-select/ng-select/ng-select/items-list';
import { AdminUtilityReportModalComponent } from './admin-utility-report-modal/admin-utility-report-modal.component';
import { environment } from '../../environments/environment';
import * as moment from 'moment-timezone';
import { DatePipe } from '@angular/common';
import { Block } from '../shared/models/block';
/**
 * @title Table with pagination
 */
@Component({
  selector: 'app-admin-utility',
  templateUrl: './admin-utility.component.html',
  //   styleUrls: ['./503error.component.css'],
  providers: [DatePipe],

  entryComponents: [SnackbarComponent],
})
export class AdminUtilityComponentInfo implements AfterViewInit {
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  constructor(
    private http: HttpClient,
    private router: Router,
    private excelService: ExcelService,
    private residentialService: ResidentialService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar
  ) {}


  ngOnInit() {

    // const button = document.getElementById('mat-tab-label-0-4');

    // button?.addEventListener('click', function handleClick(event) {
    //   console.log('button clicked');
    //   console.log(event);
    //   console.log(event.target);

    //   this.Redirect('');
    // });
    // setTimeout(function(){
    //   $('#mat-tab-label-0-5').click(function(){

    //     window.location.replace("/hg-admin-promocode-list");
    //     // this.router.navigate([
    //     //   link,''
    //     // ]);
  
    //   })

    //   $('#mat-tab-label-0-4').click(function(){

    //     window.location.replace("/hg-admin-affiliate-list");
    //     // this.router.navigate([
    //     //   link,''
    //     // ]);
  
    //   })
    // },1000)
 
    // this.fromdate = {
    //   date: {
    //     year: tdayDate.getFullYear(),
    //     month: tdayDate.getMonth() + 1,
    //     day: tdayDate.getDate(),
    //   },
    // };
    // this.todate = {
    //   date: {
    //     year: tdayDate.getFullYear(),
    //     month: tdayDate.getMonth() + 1,
    //     day: tdayDate.getDate(),
    //   },
    // };// const tdayDate = new Date();
    //  this.getEnergyProvidersReportInfo();
    //this.HgResEnergyProviderstduRates();
    // this.callResidentialAPI();
  }

  //   setEndDate(item){
  // if((item!=="Priority Move-In")){
  //   return item.
  // }
  //   }

  // getHgOrders() {
  //   this.residentialService
  //     .HgResEnergyProviderstduRates()
  //     .subscribe((response: any) => {
  //       console.log(response);
  //       this.tduBlocks = response;
  //       this.utilityData = new MatTableDataSource<tduBlock>(this.utilityBlock);
  //       // this.dataSource.paginator = this.paginator;
  //     });
  // }
  // filterChange($event) {
  //   let providersList = this.blocks.map((ItemsList: any) => {
  //     console.log('lll', ItemsList);
  //     return (ItemsList['ProviderName'] = $event.value);
  //   });
  //   this.dataSource = new MatTableDataSource<Block>(providersList);
  // }
  // deleteDataOfNewEnergyProvider(rowid: number, element) {
  //   let postobj = {
  //     ProviderName: element.ProviderName,
  //     UtilityName: element.utilityName,
  //   };
  //   this.residentialService
  //     .deleteDataOfNewEnergyProvider(postobj)
  //     .subscribe((response: any) => {
  //       // const index = this.dataSource.data.indexOf(element.id);
  //       // this.dataSource.data.splice(index, 1);
  //       // console.log('postreports', response);
  //       // this.openSnackBar(response.statusText);
  //       // this.getEnergyProvidersReportInfo();
  //     });
  // }
  openSnackBar(statusText) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      duration: 30000,
      data: {
        name: statusText,
        title: 'Error',
      },
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      panelClass: 'bg-danger',
    });
  }
  //tdu scripts
  ngAfterViewInit() {
    // this.dataSource.paginator = this.paginator;
  }
  valueChanged(event) {
    if (event) {
      // this.model = event.selectedValue;
      // this.date = this.dateObjectCstFormatted();
      // this.ans_date = moment(new Date(this.model))
      //   .format('MM/DD/YYYY')
      //   .toString();
      // this.user_bot = true;
    }
  }
  dateObjectCstFormatted() {
    // return moment(new Date(this.model))
    //   .format('YYYY-MM-DD HH:mm:ss')
    //   .toString();
  }

  Redirect(link)
  {
    this.router.navigate([
      link,''
    ]);
  }
}
